import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromAuthState from './redux/auth-state.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AuthStateEffects } from './redux/auth-state.effects';
import { ZalamoAuthService } from './zalamo-auth.service';
import { JWTService } from './jwt-parser-service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromAuthState.authStateFeatureKey,
      fromAuthState.reducer
    ),
    EffectsModule.forFeature([AuthStateEffects]),
  ],
  providers: [ZalamoAuthService, JWTService],
})
export class AuthModule {}
